<form [formGroup]="projectForm" (ngSubmit)="handleSubmit()">
    <div class="tui-row tui-row_sme">
        <div class="tui-col_12">
            <div class="tui-form__row tui-form__row_multi-fields">
                <div class="tui-form__multi-field">
                    <tui-input formControlName="nameControl">
                        Project Name
                        <input tuiTextfieldLegacy />
                    </tui-input>
                    <tui-error formControlName="nameControl" [error]="[] | tuiFieldError | async" />
                </div>
            </div>
            <div class="tui-form__row tui-form__row_multi-fields">
                <div class="tui-form__multi-field">
                    <ffx-icon-dropdown-search
                        placeholderText="Search for a project icon"
                        (iconSelected)="setIcon($event)"
                    ></ffx-icon-dropdown-search>
                </div>
            </div>

            <section class="button-section">
                <button
                    appearance="secondary"
                    iconStart="@tui.trash"
                    size="m"
                    tuiButton
                    type="button"
                    class="tui-form__button"
                    (click)="dialogDiscard()"
                >
                    Discard
                </button>
                <button
                    appearance="primary"
                    iconStart="@tui.send"
                    size="m"
                    tuiButton
                    type="submit"
                    class="create-button tui-form__button"
                >
                    Create
                </button>
            </section>
        </div>
    </div>
</form>
